export default __webpack_public_path__ + "static/media/img-0187-ireland-full-face.79a15f2f.png";